import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { ManagementApiService } from 'src/app/services';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { LicenseType } from '../../../models/organization/license-type.model';
import {
    OrganizationUserModel,
    SecurityRole,
    SecurityRoles,
    SecurityRoleUser,
    UserLicense,
    UserModelForDisplayData,
} from '../../../models/organization/organization-user.model';
import { Organization, profileContactModel } from '../../../models/organization/organization.model';
import { EditUserModalComponent } from '../../modals/organization/edit-user-modal/edit-user-modal.component';
import { OrganizationUserListComponent } from '../../modals/organization/organization-user-list/organization-user-list.component';
import { GlobalEmittersService } from '../../../../../services/global-emitters.service';
import { PermissionHierarchy } from '../../../models/organization/security-role-permission.model';
import { CustomAvatarService } from 'src/app/services/custom-avatar.service';
export interface PeriodicElement {
    position: string;
    calculation_date: string;
    calculation_type: string;
    class: number;
    size: string;
    gasket: string;
    tightening_method: string;
}

@Component({
    selector: 'app-organization-users',
    templateUrl: './organization-users.component.html',
    styleUrls: ['./organization-users.component.scss'],
    standalone: false,
})
export class OrganizationUsersComponent implements OnInit {
    @Input() isFederatedOrg: boolean;
    @Input()
    set securityRolesData(value: PermissionHierarchy[]) {
        if (value) {
            this._securityRolesData = value;
            this.getOrganizationUserTypes(value);
        }
    }
    get securityRolesData(): PermissionHierarchy[] {
        return this._securityRolesData;
    }

    @Output() navigateDetails = new EventEmitter<number>();
    @Output() navigateInstance = new EventEmitter<number>();
    @ViewChild('splashScreen', { static: true }) splashScreen: ElementRef;
    destroy$: Subject<any> = new Subject();

    searchText;
    _securityRolesData: PermissionHierarchy[];
    userDetails: OrganizationUserModel[] = [];
    userDetailsCopy: any = [];
    div1: boolean = true;
    div2: boolean = false;
    tooltip_position = 'above';
    mainProjectList = [];
    avatarSize = 100;
    temp: any;
    currentOrganizationId: string;
    isAddButtonClicked = false;
    userTypes: any = [];
    userSecurityLevels = [];
    licenseTypes = [];
    currentOrganizationName: string;
    isFedOrg: boolean = false;
    hideDeleteOption: boolean = false;
    hideEditOption: boolean = false;
    hideAddOption: boolean = false;

    userList: OrganizationUserModel[];
    userListToBeDisplay: UserModelForDisplayData[] = [];
    userListToBeDisplayCopy: UserModelForDisplayData[];
    userSecurityRoles: string[] = [];
    securityRoleWiseUser: SecurityRoleUser[];
    securityRoleWiseUserCopy: SecurityRoleUser[];
    isListView: boolean;
    isGridView: boolean;
    activeOrganization: Organization;

    constructor(
        private modalService: NgbModal,
        private managementApiService: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private activatedRoute: ActivatedRoute,
        private organizationDataService: OrganizationDataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private globalEmittersService: GlobalEmittersService,
        private customAvatarService: CustomAvatarService
    ) {
        this.userList = [];
        this.securityRoleWiseUser = [];
        this.userListToBeDisplayCopy = [];
        this.isListView = false;
        this.isGridView = true;
    }

    async ngOnInit(): Promise<void> {
        this.hideDeleteOption = await this.user_utility.checkUserPermissionDataAndRoute('org-user', userActions.Delete);
        this.hideEditOption = await this.user_utility.checkUserPermissionDataAndRoute('org-user', userActions.Edit);
        this.hideAddOption = await this.user_utility.checkUserPermissionDataAndRoute('org-user', userActions.Create);

        this.organizationDataService.activeOrganizationTab.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == 'Users') {
                this.intializeComponanat();
            }
        });

        this.organizationDataService.currentOrganizationName.pipe(takeUntil(this.destroy$)).subscribe((orgName) => {
            this.currentOrganizationName = orgName;
        });

        this.organizationDataService.isFederatedOrganization$.pipe(takeUntil(this.destroy$)).subscribe((value: boolean) => {
            this.isFedOrg = value;
        });

        this.organizationDataService.organizationID.pipe(takeUntil(this.destroy$)).subscribe((id: string) => {
            this.currentOrganizationId = id;
        });

        this.globalEmittersService.currentOrganization.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.activeOrganization = res;
            }
        });

        this.organizationDataService.organizationTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == 'Users') {
                this.navigate();
            }
        });

        this.organizationDataService.OrganizationTabBack.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == 'Users') {
                this.navigateBack();
            }
        });
    }

    async intializeComponanat() {
        if (this.activatedRoute.snapshot.paramMap.get('id')) {
            // this.getOrganizationUsers();
            await this.getOrganizationUserList(this.activatedRoute.snapshot.paramMap.get('id'));
            this.currentOrganizationId = this.activatedRoute.snapshot.paramMap.get('id');
            this.organizationDataService.organizationID.subscribe((id: string) => {
                this.currentOrganizationId = id;
            });

            await this.getUserLicenseType();
            // await this.getOrganizationUserTypes(); // here error occurs because the organization id is not created yet
        }
    }

    div1Function() {
        this.div1 = true;
        this.avatarSize = 100;
    }

    div2Function() {
        this.div1 = false;
        this.avatarSize = 40;
    }

    getOrganizationUsers(): Promise<any> {
        return new Promise<true>(async (resolve, reject) => {
            this.ngxUiLoaderService.start();
            let orgId;
            if (this.activatedRoute.snapshot.paramMap.get('id')) {
                orgId = this.activatedRoute.snapshot.paramMap.get('id');
            } else {
                orgId = this.currentOrganizationId;
            }
            this.userDetailsCopy = [];
            let organizationUsers = await this.managementApiService.getUsersForOrganization(orgId).toPromise();

            if (organizationUsers.success === true) {
                this.organizationDataService.numberOfUsers.next(organizationUsers.response.length);
                this.userDetails = [];
                if (organizationUsers.response.length) {
                    organizationUsers.response.forEach((orgUser) => {
                        let userObject = {
                            userId: orgUser?.userId,
                            firstName: orgUser?.profileContact?.firstName,
                            lastName: orgUser?.profileContact?.lastName,
                            email: orgUser?.profileContact?.email,
                            securityRole: {
                                name: orgUser?.securityRoles[0]?.securityRole?.name,
                            },
                        };

                        let userDetail = new OrganizationUserModel();
                        let userProfileContact = new profileContactModel();
                        let userSecurityRole = new SecurityRole();
                        let userSecurityRoles = new SecurityRoles();
                        let userLicense = new UserLicense();
                        let userLicenseType = new LicenseType();

                        // Assigning user detail fields
                        userDetail.userId = orgUser?.userId;
                        userDetail.organisationID = orgUser?.organisation?.organisationId;

                        // Profile Contact
                        userProfileContact.profileContactId = orgUser?.profileContact?.profileContactId;
                        userProfileContact.firstName = orgUser?.profileContact?.firstName;
                        userProfileContact.lastName = orgUser?.profileContact?.lastName;
                        userProfileContact.email = orgUser?.profileContact?.email;

                        // Security Roles
                        userSecurityRoles.userId = orgUser?.userId;
                        userSecurityRoles.userSecurityRoleId = orgUser?.securityRoles[0]?.userSecurityRoleId;
                        userSecurityRole.securityRoleId = orgUser?.securityRoles[0]?.securityRole?.securityRoleId;
                        userSecurityRole.name = orgUser?.securityRoles[0]?.securityRole?.name;
                        userSecurityRoles.securityRole = userSecurityRole;

                        // License
                        userLicense.licenseId = orgUser?.license?.licenseId;
                        userLicenseType.licenseTypeId = orgUser?.license?.licenseType?.licenseTypeId;
                        userLicenseType.name = orgUser?.license?.licenseType?.name;
                        userLicense.instanceTypeIndex = orgUser?.license?.instanceTypeIndex;
                        userLicense.startDate = orgUser?.license?.startDate;
                        userLicense.endDate = orgUser?.license?.endDate;
                        userLicense.licenseType = userLicenseType;

                        // Setting the details in the user model
                        userDetail.profileContact = userProfileContact;
                        userDetail.securityRoles = [userSecurityRoles];
                        userDetail.license = userLicense;

                        // Adding to arrays
                        this.userDetails.push(userDetail);
                        this.userDetailsCopy.push(userObject);
                    });
                }

                this.temp = this.userDetailsCopy;
                this.ngxUiLoaderService.stop();
            } else {
                this.ngxUiLoaderService.stop();
                // this.user_utility.errorModelPopup(organizationUsers.message)
            }
        });
    }

    openCustomModal() {
        let dialogRef = this.modalService.open(OrganizationUserListComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
        });
        dialogRef.componentInstance.currentOrganizationId = this.activatedRoute.snapshot.paramMap.get('id')
            ? this.activatedRoute.snapshot.paramMap.get('id')
            : this.organizationDataService.organizationData.organisationId;
        dialogRef.componentInstance.activeOrganization = this.activeOrganization;
        dialogRef.componentInstance.securityRoles = this._securityRolesData;
        dialogRef.result
            .then(async (result) => {
                if (result) {
                    // this.getOrganizationUsers();
                    await this.managegetOrganizationUserListApiCall(this.currentOrganizationId);
                }
            })
            .catch((res) => {
                console.warn(res);
            });
    }

    searchResult(event) {
        this.userListToBeDisplay = [];
        this.userListToBeDisplay = this.userListToBeDisplayCopy.filter((item) => {
            return (
                (
                    (item?.firstName !== undefined ? item?.firstName : '').toLowerCase() +
                    ' ' +
                    (item?.lastName !== undefined ? item?.lastName : '').toLowerCase()
                )
                    .trim()
                    .includes(event.target.value.trim().toLowerCase()) ||
                (item?.userEmail !== undefined ? item?.userEmail : '').toLowerCase().includes(event.target.value.trim().toLowerCase())
            );
        });

        let securityRoleListWhileSearch: string[] = [];
        this.userListToBeDisplay.forEach((user) => {
            let index = securityRoleListWhileSearch.findIndex((item) => {
                if (user?.securityRoleName) return item == user.securityRoleName;

                return false;
            });
            if (index == -1 && user?.securityRoleName) {
                securityRoleListWhileSearch.push(user.securityRoleName);
            }
        });

        let searchResult = securityRoleListWhileSearch.map((item) => {
            return {
                secuirtyRoleName: item,
                usersList: this.userListToBeDisplay.filter((user) => user?.securityRoleName == item),
            };
        });

        searchResult.sort((a, b) => {
            return b.usersList.length - a.usersList.length;
        });

        this.securityRoleWiseUser = searchResult;
    }

    deleteUser(user: any) {
        let dialogRef = this.modalService.open(ConfirmationDialogComponent, {
            size: 'sm',
        });
        dialogRef.componentInstance.modalMessage = `Do you want to delete this "${user.firstName} - ${user.lastName}" user?`;
        dialogRef.result
            .then((result) => {
                if (result) {
                    this.ngxUiLoaderService.start();
                    this.managementApiService.deleteOrganizationUser(user.userId).subscribe(
                        async (resposne) => {
                            if (resposne.success === true) {
                                // this.getOrganizationUsers().then(res=>{
                                //   this.ngxUiLoaderService.stop();
                                // }).catch(err=>{
                                //   this.ngxUiLoaderService.stop();
                                // });
                                await this.managegetOrganizationUserListApiCall(this.currentOrganizationId);
                            } else {
                                this.user_utility.errorModelPopup(resposne.message);
                            }
                            this.ngxUiLoaderService.stop();
                            //here success toast will be displayed
                        },
                        (error) => {
                            this.ngxUiLoaderService.stop();
                            //here error toast will be displayed
                        }
                    );
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    navigateBack() {
        this.organizationDataService.isDisableUsersWizard.next(true);

        this.organizationDataService.isDisableUserTypeWizard.next(false);
        if (this.isFedOrg) {
            this.organizationDataService.navigateThroughWizard.next(2);
        } else {
            this.organizationDataService.navigateThroughWizard.next(1);
        }
    }

    navigate() {
        this.organizationDataService.isDisableUsersWizard.next(true);
        this.organizationDataService.isDisableInstanceWizard.next(false);
        if (this.isFedOrg) {
            this.organizationDataService.navigateThroughWizard.next(4);
        } else {
            this.organizationDataService.navigateThroughWizard.next(3);
        }
    }

    editUser(user) {
        let dialogRef = this.modalService.open(EditUserModalComponent, {
            size: 'lg',
        });
        dialogRef.componentInstance.modalMode = 'Update';
        dialogRef.componentInstance.userTypes = this.organizationDataService.userRoles;
        //dialogRef.componentInstance.userSecurityLevels = this.userSecurityLevels;
        dialogRef.componentInstance.licenseType = this.licenseTypes;
        dialogRef.componentInstance.organizationUser = this.findUser(user.userId);
        dialogRef.componentInstance.activeOrganization = this.activeOrganization;
        dialogRef.componentInstance.currentOrganizationId = this.currentOrganizationId;
        dialogRef.result
            .then(async (result) => {
                if (result) {
                    // this.getOrganizationUsers();
                    this.managegetOrganizationUserListApiCall(this.currentOrganizationId);
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    viewUser(user) {
        let dialogRef = this.modalService.open(EditUserModalComponent, {
            size: 'lg',
        });
        dialogRef.componentInstance.modalMode = 'View';
        dialogRef.componentInstance.userTypes = this.organizationDataService.userRoles;
        //dialogRef.componentInstance.userSecurityLevels = this.userSecurityLevels;
        dialogRef.componentInstance.licenseType = this.licenseTypes;
        dialogRef.componentInstance.organizationUser = this.findUser(user.userId);
        dialogRef.componentInstance.currentOrganizationId = this.currentOrganizationId;
    }

    getOrganizationUserTypes(securityRoles) {
        if (!this.userTypes?.length) {
            // this.managementApiService
            //     .getSecurityRolesByOrgId(this.currentOrganizationId || this.activatedRoute.snapshot.paramMap.get('id'))
            //     .subscribe((res) => {
            if (securityRoles) {
                for (let x = 0; x < securityRoles.length; x++) {
                    this.userTypes.push(securityRoles[x].name);
                }
                this.organizationDataService.setUserRoles(this.userTypes, securityRoles);
            }
            // });
        }
    }

    getUserLicenseType() {
        if (!this.licenseTypes?.length) {
            this.managementApiService.getLicenseType().subscribe((res) => {
                if (res.success) {
                    this.licenseTypes = res.response;
                    this.organizationDataService.setUserLicenseType(res.response);
                } else {
                    this.user_utility.errorModelPopup(res.message);
                }
            });
        }
    }

    //helper method
    findUser(userId: string) {
        for (let x = 0; x < this.userList.length; x++) {
            if (this.userList[x].userId == userId) {
                return this.userList[x];
            }
        }
    }

    // * helper method for controlling hover effect css dynamically
    manageHover(index: number) {
        let element = document.getElementById('kt_body').lastChild as HTMLElement;
        switch (index) {
            case 0:
                element.classList.add('hover-custom');
                break;

            case 1:
                element.classList.remove('hover-custom');
                break;
        }
    }

    // * api call to get the user of organization
    async getOrganizationUserList(orgID: string) {
        try {
            if (!this.userList?.length) {
                await this.managegetOrganizationUserListApiCall(orgID);
            }
        } catch (e) {}
    }

    async managegetOrganizationUserListApiCall(orgID: string) {
        try {
            this.ngxUiLoaderService.start();
            let res = await this.managementApiService.getUsersForOrganization(orgID).pipe(takeUntil(this.destroy$)).toPromise();

            this.ngxUiLoaderService.stop();
            if (res.success) {
                this.userList = res.response;
                this.organizationDataService.numberOfUsers.next(res.response.length);
                this.userListToBeDisplay = this.userList.map((user) => {
                    if (user.securityRoles != undefined) {
                        let userRole = this.userSecurityRoles?.findIndex((item) => item == user?.securityRoles[0]?.securityRole?.name);
                        if (userRole == -1) {
                            this.userSecurityRoles.push(user.securityRoles[0].securityRole.name);
                        }
                        return {
                            userId: user.userId,
                            firstName: user?.profileContact?.firstName,
                            lastName: user?.profileContact?.lastName,
                            userEmail: user?.profileContact?.email,
                            securityRoleName: user.securityRoles[0]?.securityRole?.name,
                        };
                    }
                });
                this.userListToBeDisplayCopy = this.userListToBeDisplay.slice();
                this.securityRoleWiseUser = this.differenateUserBasedOnRole().sort((a, b) => {
                    return b.usersList.length - a.usersList.length;
                });
                this.securityRoleWiseUserCopy = this.securityRoleWiseUser.slice();
            } else if (res.isCustom) {
                // this.user_utility.errorModelPopup(res.message);
            }
        } catch (e) {}
    }

    // * differeniate user based on secuirty role
    differenateUserBasedOnRole() {
        let modifiedArray = [];
        this.userSecurityRoles.forEach((role) => {
            let usersOfSpecificRoles = this.userListToBeDisplayCopy.filter((user) => user?.securityRoleName == role && user?.securityRoleName != undefined);
            if (usersOfSpecificRoles?.length > 0) {
                modifiedArray.push({
                    secuirtyRoleName: role,
                    usersList: usersOfSpecificRoles.map((user) => {
                        return {
                            userId: user.userId,
                            firstName: user.firstName,
                            lastName: user.lastName,
                            userEmail: user.userEmail,
                            securityRoleName: user.securityRoleName,
                        };
                    }),
                });
            }
        });
        this.cd.detectChanges();
        return modifiedArray;
    }

    // * handle user view
    handleUserView(index: number) {
        if (index == 0) {
            this.isGridView = true;
            this.isListView = false;
            this.avatarSize = 100;
        } else {
            this.isGridView = false;
            this.isListView = true;
            this.avatarSize = 40;
        }
    }

    // * check text oveflow
    checkIsTextOverflow(hoverProperty: string, elementId: string): boolean {
        let element;
        switch (hoverProperty) {
            case 'firstName':
                element = document.getElementById(`${elementId}-first-name`);
                break;

            case 'lastName':
                element = document.getElementById(`${elementId}-last-name`);
                break;

            case 'email':
                element = document.getElementById(`${elementId}-email`);
                break;

            case 'role':
                element = document.getElementById(`${elementId}-role`);
                break;
        }

        if (element) {
            return element.scrollWidth > element.offsetWidth;
        } else {
            return false;
        }
    }

    getInitials(name: string): string {
        if (!name) return '';
        return this.customAvatarService.getShortInitials(name);
    }
    getUserDisplayName(user: any, index: number): string {
        return `${user?.firstName || ''} ${user?.lastName || ''} ${index || ''}`.trim();
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
